module.exports = __webpack_public_path__ + "img/dasboard-jobs.4c3595ba.png";